export const BatchOption = {
  DELETE: 'DELETE',
  COPY: 'COPY',
  MOVE: 'MOVE',
};

export const BatchOptionList = [
  {
    label: 'Törlés',
    value: BatchOption.DELETE,
  },
  {
    label: 'Másolás',
    value: BatchOption.COPY,
  },
  {
    label: 'Mozgatás',
    value: BatchOption.MOVE,
  },
];
